(() => {
  const SQUARE_PRICES = {
    '2x2': { 50: 5700, 100: 7000, 200: 9200, 300: 11100, 500: 14700, 1000: 22500, 2000: 36000, 3000: 48100, 5000: 70200 },
    '3x3': { 50: 6900, 100: 9100, 200: 12800, 300: 16200, 500: 22400, 1000: 36100, 2000: 60000, 3000: 81600, 5000: 121200 },
    '4x4': { 50: 8400, 100: 11600, 200: 17300, 300: 22500, 500: 32000, 1000: 53000, 2000: 89800, 3000: 123200, 5000: 184400 },
    '5x5': { 50: 10100, 100: 14600, 200: 22600, 300: 29900, 500: 43200, 1000: 72800, 2000: 124900, 3000: 172100, 5000: 258600 },
  };
  const PRODUCT_CONFIGS = {
    'die-cut': {
      prices: SQUARE_PRICES,
      quantities: [50, 100, 200, 300, 500, 1000, 2000, 3000, 5000],
      defaultShape: 'Contour Cut', defaultSize: '3x3', defaultSizeLabel: '3 × 3 in', defaultQuantity: 300,
      unitSingular: 'sticker', unitPlural: 'Stickers',
    },
    'qr-code': {
      prices: {
        '2x4': { 50: 6700, 100: 8700, 200: 12100, 300: 15200, 500: 20900, 1000: 33500, 2000: 55500, 3000: 75300, 5000: 111500 },
        '2.5x5': { 50: 7700, 100: 10400, 200: 15100, 300: 19400, 500: 27300, 1000: 44700, 2000: 75300, 3000: 103000, 5000: 153600 },
        '3x6': { 50: 8800, 100: 12300, 200: 18600, 300: 24200, 500: 34500, 1000: 57500, 2000: 97900, 3000: 134400, 5000: 201400 },
        '4x8': { 50: 11300, 100: 16800, 200: 26500, 300: 35300, 500: 51400, 1000: 87300, 2000: 150500, 3000: 207800, 5000: 315500 },
      },
      quantities: [50, 100, 200, 300, 500, 1000, 2000, 3000, 5000],
      defaultShape: 'Contour Cut', defaultSize: '2.5x5', defaultSizeLabel: '2.5 × 5 in', defaultQuantity: 300,
      unitSingular: 'sticker', unitPlural: 'Stickers',
    },
    'kiss-cut': {
      prices: SQUARE_PRICES,
      quantities: [50, 100, 200, 300, 500, 1000, 2000, 3000, 5000],
      defaultShape: 'Contour Cut', defaultSize: '3x3', defaultSizeLabel: '3 × 3 in', defaultQuantity: 300,
      unitSingular: 'sticker', unitPlural: 'Stickers',
    },
    'sticker-sheet': {
      prices: {
        '4x6': { 30: 7800, 50: 11800, 100: 17500, 200: 27700, 300: 36900, 500: 53800, 1000: 91500 },
        '7x10': { 30: 14400, 50: 21800, 100: 35300, 200: 59000, 300: 80600, 500: 120200, 1000: 208600 },
        '8.5x11': { 30: 17500, 50: 26400, 100: 43400, 200: 73400, 300: 100600, 500: 150600, 1000: 262300 },
        '11x17': { 30: 28400, 50: 43100, 100: 72800, 200: 125300, 300: 173100, 500: 260800, 1000: 456800 },
      },
      quantities: [30, 50, 100, 200, 300, 500, 1000],
      defaultShape: 'Rectangle', defaultSize: '4x6', defaultSizeLabel: '4 × 6 in', defaultQuantity: 100,
      unitSingular: 'sheet', unitPlural: 'Sheets',
    },
  };
  const formatMoney = (cents, currency) => new Intl.NumberFormat(undefined, { style: 'currency', currency, minimumFractionDigits: 2 }).format(cents / 100);
  const activate = (buttons, active) => buttons.forEach((button) => {
    const selected = button === active;
    button.classList.toggle('is-selected', selected);
    button.setAttribute('aria-pressed', String(selected));
  });

  const init = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-sticker-form]');
    const dataNode = root.querySelector('[data-product-variants]');
    if (!form || !dataNode) return;

    let productData = { optionNames: [], variants: [] };
    try { productData = JSON.parse(dataNode.textContent); } catch (error) { console.error('Custom sticker variants could not be read.', error); }
    const config = PRODUCT_CONFIGS[root.dataset.stickerType] || PRODUCT_CONFIGS['die-cut'];
    const showVolumeSavings = true;
    const currency = root.dataset.currency || 'USD';
    const state = {
      shape: config.defaultShape,
      size: config.defaultSize,
      sizeLabel: config.defaultSizeLabel,
      finish: 'Gloss',
      quantity: config.defaultQuantity,
      quoteMode: false,
    };
    const el = {
      variantId: form.querySelector('[data-variant-id]'), shapeProperty: form.querySelector('[data-shape-property]'),
      sizeProperty: form.querySelector('[data-size-property]'), quantityProperty: form.querySelector('[data-quantity-property]'),
      finishProperty: form.querySelector('[data-finish-property]'),
      quantityList: form.querySelector('[data-quantity-list]'),
      customSize: form.querySelector('[data-custom-size]'),
      artwork: form.querySelector('[data-artwork-file]'), uploadPanel: form.querySelector('[data-upload-panel]'),
      uploadTitle: form.querySelector('[data-upload-title]'), uploadHelp: form.querySelector('[data-upload-help]'),
      deferArtwork: form.querySelector('[data-defer-artwork]'), artworkDelivery: form.querySelector('[data-artwork-delivery]'),
      summary: form.querySelector('[data-order-summary]'), total: form.querySelector('[data-summary-total]'),
      unit: form.querySelector('[data-summary-unit]'), unitLabel: form.querySelector('[data-summary-unit-label]'),
      quote: form.querySelector('[data-quote-panel]'), cancelQuote: form.querySelector('[data-cancel-quote]'),
      submit: form.querySelector('[data-add-to-cart]'), status: form.querySelector('[data-status]'),
      backInStock: root.querySelector('hdt-back-instock'),
      backInStockSelect: root.querySelector('[back-instock-select]'),
    };
    const emptyArtworkLabel = 'Add to Cart';
    const clearStatus = () => { el.status.textContent = ''; el.status.classList.remove('is-error', 'is-success'); };
    const findVariant = (pricingSize) => {
      const sizeIndex = productData.optionNames.findIndex((name) => /size/i.test(name));
      const quantityIndex = productData.optionNames.findIndex((name) => /quantity/i.test(name));
      return productData.variants.find((variant) => {
        const size = String(variant.options[sizeIndex] || '')
          .toLowerCase()
          .replace(/[″"\s]/g, '')
          .replace('×', 'x')
          .replace(/in(?:ch(?:es)?)?$/, '');
        const quantity = Number(String(variant.options[quantityIndex] || '').replace(/\D/g, ''));
        return size === pricingSize && quantity === state.quantity;
      });
    };

    const update = () => {
      const quoteRequired = state.quoteMode;
      el.summary.hidden = quoteRequired;
      el.quote.hidden = !quoteRequired;
      el.shapeProperty.value = state.shape;
      el.finishProperty.value = state.finish;
      el.sizeProperty.value = state.sizeLabel;
      el.quantityProperty.value = state.quantity;
      if (quoteRequired) {
        el.variantId.value = '';
        if (el.backInStock) el.backInStock.hidden = true;
        return;
      }

      const variant = findVariant(state.size);
      const showBackInStock = Boolean(variant && !variant.available);
      if (el.backInStock) {
        el.backInStock.hidden = !showBackInStock;
        if (showBackInStock && el.backInStockSelect) {
          el.backInStockSelect.value = String(variant.id);
          el.backInStockSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      const fallbackPrice = config.prices[state.size] && config.prices[state.size][state.quantity];
      const cents = variant && Number.isFinite(Number(variant.price)) ? Number(variant.price) : fallbackPrice;
      if (!Number.isFinite(cents)) return;
      el.total.textContent = formatMoney(cents, currency);
      el.unit.textContent = formatMoney(Math.round(cents / state.quantity), currency);
      if (el.unitLabel) el.unitLabel.textContent = `per ${config.unitSingular}`;
      el.variantId.value = variant ? variant.id : '';
      el.submit.disabled = !variant || !variant.available;
      if (!variant) {
        el.status.textContent = 'This package is not configured in Shopify yet.';
        el.status.classList.add('is-error');
      } else if (!variant.available) {
        el.status.textContent = 'This package is currently unavailable.';
        el.status.classList.add('is-error');
      } else if (el.status.classList.contains('is-error')) clearStatus();
    };

    const renderQuantities = () => {
      const table = config.prices[state.size];
      const baseQuantity = config.quantities[0];
      const baseUnitPrice = table[baseQuantity] / baseQuantity;
      el.quantityList.replaceChildren(...config.quantities.map((quantity) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.quantity = String(quantity);
        button.setAttribute('aria-pressed', String(quantity === state.quantity));
        if (quantity === state.quantity) button.classList.add('is-selected');
        const count = document.createElement('strong'); count.textContent = `${quantity.toLocaleString()} ${config.unitPlural}`;
        const price = document.createElement('span'); price.textContent = formatMoney(table[quantity], currency);
        if (showVolumeSavings) {
          const savings = (1 - ((table[quantity] / quantity) / baseUnitPrice)) * 100;
          button.append(count, price);
          if (savings > 0.05) {
            const discount = document.createElement('small');
            discount.className = 'sw-die-cut__savings';
            discount.textContent = `Save ${savings.toFixed(1).replace('.0', '')}%`;
            button.append(discount);
          }
        } else {
          const perSticker = document.createElement('small'); perSticker.textContent = `${formatMoney(Math.round(table[quantity] / quantity), currency)} each`;
          button.append(count, price, perSticker);
        }
        button.addEventListener('click', () => { state.quantity = quantity; state.quoteMode = false; activate(el.quantityList.querySelectorAll('button'), button); clearStatus(); update(); });
        return button;
      }));
    };

    root.querySelectorAll('[data-shape]').forEach((button) => button.addEventListener('click', () => {
      state.shape = button.dataset.shape; activate(root.querySelectorAll('[data-shape]'), button);
      update();
    }));
    root.querySelectorAll('[data-size]').forEach((button) => button.addEventListener('click', () => {
      state.size = button.dataset.size; state.sizeLabel = button.dataset.sizeLabel || ''; state.quoteMode = false;
      activate(root.querySelectorAll('[data-size]'), button); clearStatus(); renderQuantities(); update();
    }));
    root.querySelectorAll('[data-finish]').forEach((button) => button.addEventListener('click', () => {
      state.finish = button.dataset.finish; activate(root.querySelectorAll('[data-finish]'), button); update();
    }));
    if (el.customSize) {
      el.customSize.addEventListener('click', () => {
        state.quoteMode = true;
        update(); el.quote.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
    if (el.cancelQuote) {
      el.cancelQuote.addEventListener('click', () => {
        state.quoteMode = false;
        clearStatus(); update();
        el.customSize.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    const setDeferredArtwork = (deferred) => {
      if (!el.deferArtwork || !el.artworkDelivery) return;
      el.deferArtwork.classList.toggle('is-selected', deferred);
      el.deferArtwork.setAttribute('aria-pressed', String(deferred));
      el.artworkDelivery.value = deferred ? 'Customer will email artwork after placing the order' : '';
      el.artwork.disabled = deferred;
      el.artwork.closest('.sw-die-cut__upload')?.classList.toggle('is-disabled', deferred);
      if (deferred) {
        el.artwork.value = '';
        el.uploadTitle.textContent = 'Artwork will be sent after ordering';
        el.uploadHelp.textContent = 'Email your files with the order number from your confirmation.';
      } else {
        el.uploadTitle.textContent = 'Choose your artwork';
        el.uploadHelp.textContent = 'PNG, JPG, PDF, AI, EPS, or SVG · 20 MB maximum';
      }
      clearStatus();
      el.submit.textContent = 'Add to Cart';
    };
    if (el.deferArtwork) {
      el.deferArtwork.addEventListener('click', () => {
        setDeferredArtwork(el.deferArtwork.getAttribute('aria-pressed') !== 'true');
      });
    }

    el.artwork.addEventListener('change', () => {
      clearStatus(); const file = el.artwork.files && el.artwork.files[0];
      if (file && el.deferArtwork) setDeferredArtwork(false);
      if (!file) {
        el.uploadTitle.textContent = 'Choose your artwork';
        el.uploadHelp.textContent = 'PNG, JPG, PDF, AI, EPS, or SVG · 20 MB maximum';
        el.submit.textContent = emptyArtworkLabel;
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        el.artwork.value = ''; el.submit.textContent = emptyArtworkLabel; el.status.textContent = 'Artwork must be 20 MB or smaller.'; el.status.classList.add('is-error'); return;
      }
      el.uploadTitle.textContent = file.name; el.uploadHelp.textContent = `${(file.size / 1024 / 1024).toFixed(2)} MB selected`;
      el.submit.textContent = 'Add to Cart';
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault(); clearStatus();
      const artworkDeferred = el.deferArtwork && el.deferArtwork.getAttribute('aria-pressed') === 'true';
      if ((!el.artwork.files || !el.artwork.files[0]) && !artworkDeferred) {
        const wasHidden = el.uploadPanel.hidden;
        el.uploadPanel.hidden = false;
        el.status.textContent = wasHidden ? 'Choose your artwork to continue.' : 'Upload your artwork before adding this order to your cart.';
        if (!wasHidden) el.status.classList.add('is-error');
        el.uploadPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => el.artwork.focus(), 350);
        return;
      }
      if (!el.variantId.value) { el.status.textContent = 'This package is not ready for checkout yet.'; el.status.classList.add('is-error'); return; }
      const label = el.submit.textContent; el.submit.disabled = true; el.submit.textContent = 'Adding…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const result = await response.json(); if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this order.');
        document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { item: result } }));
        el.status.textContent = artworkDeferred
          ? 'Added to cart. Email your artwork with the order number from your confirmation.'
          : 'Added to cart. Your artwork is attached to this order.';
        el.status.classList.add('is-success'); el.submit.textContent = 'Added to Cart';
        window.setTimeout(() => { el.submit.textContent = label; el.submit.disabled = false; }, 1800);
      } catch (error) {
        el.status.textContent = error.message || 'We could not add this order. Please try again.'; el.status.classList.add('is-error'); el.submit.textContent = label; el.submit.disabled = false;
      }
    });
    renderQuantities(); update();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-sticker-configurator]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
